import axios from "axios";
// import { useLoading } from "../contexts/LoadingContext";

export const Config = {
    BaseUrl(subdomain) {
        if (!subdomain) subdomain = Config.subDomain();
        if (Config.domain()) subdomain += ".";
        return `${Config.protocol()}//${subdomain}${Config.domain()}${Config.port()}`;
    },
    SystemUrl(domain) {
        return `${Config.protocol()}//${domain}${Config.port()}`;
    },
    subDomain: () => process.env?.REACT_APP_SUBDOMAIN ?? window.location.hostname.split('.')[0],
    domain: () => process.env?.REACT_APP_DOMAIN ?? window.location.hostname.split('.').slice(1).join("."),
    port: () => process.env?.REACT_APP_PORT ? `:${process.env.REACT_APP_PORT}` : "",
    protocol: () => process.env?.REACT_APP_PROTOCOL ?? window.location.protocol,
    Connection: () => {
        let ax = axios.create({
            baseURL: Config.BaseUrl(),
            headers: { "User-Token": window.localStorage.token },
            // onDownloadProgress: (e) => {
            //     const lc = useLoading();
            //     lc.update({ percentage: (e.loaded / e.total) * 100 })
            // }
        })
        ax.defaults.withCredentials = true;
        return ax
    }
} 